import { useEffect } from 'react';

import TagManager from 'react-gtm-module';
import { parseEventTicketsForGTM } from 'utils/gtmUtils';
import { TicketSalePageEvent } from './slice/types';

const useViewItemListGTM = (props: TicketSalePageEvent) => {
  const { gtm_code, name, tickets, tax_rate } = props;

  useEffect(() => {
    const tagManagerArgs = {
      dataLayer: {
        event: 'view_item_list',
        ecommerce: {
          item_list_name: name,
          items: parseEventTicketsForGTM(tickets, tax_rate.rate),
        },
      },
    };

    TagManager.dataLayer({
      dataLayer: { event: 'remove_from_cart', ecommerce: null },
    });
    TagManager.dataLayer(tagManagerArgs);
  }, [gtm_code, name, tickets, tax_rate.rate]);

  return null;
};

export default useViewItemListGTM;
